import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import _ from "lodash";
import { reusableFetch } from "@/utils/useFetch";

export const updateAsset = createAsyncThunk("asset/updateAsset", async (data, { rejectWithValue }) => {
  const asset = await reusableFetch(`asset/`, "POST", data, rejectWithValue);
  return asset;
});

export const applicationsAssetSlice = createSlice({
  name: "asset",
  initialState: {
    liabilitiesListData: [
      {
        liabilitiesType: "",
        outstandingAmount: "",
        limit: "",
        financier: "",
        repaymentFrequency: "",
        repaymentAmount: "",
        description: "",
        shareOfLiability: 100,
        application: "",
        customer: "",
      },
    ],
    assetListData: [
      {
        description: "",
        assetType: "",
        value: "",
        application: "",
        customer: "",
      },
    ],
    incomeListData: [
      {
        incomeType: "",
        frequency: "",
        amount: "",
        application: "",
        customer: "",
      },
    ],
    isLoading: false,
    application: {
      asset: {},
    },
  },
  reducers: {
    saveValue: (state, action) => _.merge(state, action.payload),
  },
  extraReducers: {
    // [updateAssets.fulfilled]: (state, { payload }) => {
    // state.application.customers.filter(
    //   (customer) => customer._id === payload.data.customer
    // )[0] = _.merge(
    //   state.application.customers.filter(
    //     (customer) => customer._id === payload.data.customer
    //   )[0].customerAssets,
    //   payload.data
    // );
    // },
  },
});

export const { saveValue } = applicationsAssetSlice.actions;

export const assetSelector = (state) => state.asset;
